// extracted by mini-css-extract-plugin
export default {"musicContainer":"Music_musicContainer__GgUDS"};